import React, { useState } from "react";
import LeftPanel from "../components/LeftPanel";
import RightSide from "../components/RightSide";

const Page1 = () => {

  const [isItemAvilableOpen, setIsItemAvilableOpen] = useState(false);
  const [isMealSchedulingOpen, setIsMealSchedulingOpen] = useState(false);
  const [isOrdersTablePopUpOpen, setIsOrdersTablePopUpOpen] = useState(false);
  const [isDailyReportSummary, setIsDailyReportSummary] = useState(false);
  sessionStorage.setItem("selected-page", "/page1");

  return (
    <>
      <LeftPanel
        setIsItemAvilableOpen={setIsItemAvilableOpen}
        isItemAvilableOpen={isItemAvilableOpen}
        setIsDailyReportSummary={setIsDailyReportSummary}
        isDailyReportSummary={isDailyReportSummary}
        isMealSchedulingOpen={isMealSchedulingOpen}
        setIsMealSchedulingOpen={setIsMealSchedulingOpen}
      />
      <RightSide
        setIsItemAvilableOpen={setIsItemAvilableOpen}
        isItemAvilableOpen={isItemAvilableOpen}
        isOrdersTablePopUpOpen={isOrdersTablePopUpOpen}
        setIsOrdersTablePopUpOpen={setIsOrdersTablePopUpOpen}
        setIsDailyReportSummary={setIsDailyReportSummary}
        isDailyReportSummary={isDailyReportSummary}
        isMealSchedulingOpen={isMealSchedulingOpen}
        setIsMealSchedulingOpen={setIsMealSchedulingOpen}
      />
    </>
  );
};

export default Page1;
